/*
 *
 * AccountPage actions
 *
 */

import {
  DEFAULT_ACTION,
  PATCH_ACCOUNT_REQUEST,
  PUT_ACCOUNT_SUCCESS,
  PUT_ACCOUNT_FAILURE,
  RESEND_EMAIL_CONFIRMATION,
  RESEND_EMAIL_CONFIRMATION_SUCCESS,
  RESEND_EMAIL_CONFIRMATION_FAILURE,
  DELETE_ACCOUNT_REQUEST,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export const patchAccountRequest = (payload) => ({
  type: PATCH_ACCOUNT_REQUEST,
  payload
})

export const putAccountSuccess = (payload) => {
  return {
    type: PUT_ACCOUNT_SUCCESS,
    payload
  }
};

export const putAccountFailure = (payload) => ({
  type: PUT_ACCOUNT_FAILURE,
  payload
});

export const sendEmailConfirmation  = {
    type: RESEND_EMAIL_CONFIRMATION
}

export const resendEmailConfirmationFailure = (payload) => ({
  type: RESEND_EMAIL_CONFIRMATION_SUCCESS,
  payload
})

export const resendEmailConfirmationSuccess = (payload) => ({
  type: RESEND_EMAIL_CONFIRMATION_FAILURE,
  payload
})

export const deleteAccountRequest = (payload) => ({
  type: DELETE_ACCOUNT_REQUEST,
  payload
});

export const deleteAccountSuccess = (payload) => ({
  type: DELETE_ACCOUNT_SUCCESS,
  payload
});

export const deleteAccountFailure = (payload) => ({
  type: DELETE_ACCOUNT_FAILURE,
  payload
});
